export default {
   expires:7200,                         //登录过期时间
   token_name:'token',                   //token名称
  login_path:'/site/login',             //登录路径
  forbidden_path:'/403',                //无权限页面
  index_path:'/justlink/index',           //首页路径
  brand_name:'佳视联',                 //品牌名称
  project_name:'JustLink-workbench',     //项目名称
  pc_domain:process.env.PC_DOMAIN,
  m_domain:process.env.M_DOMAIN,


}



// WEBPACK FOOTER //
// ./src/utils/config/config.js